import CryptoJS from "crypto-js";

export function encrypted(plainText) {
  var key = CryptoJS.enc.Utf8.parse("ekatalogapjii_ia");
  var iv = CryptoJS.enc.Utf8.parse("I__20111995__Via");
  var encrypted = CryptoJS.AES.encrypt(JSON.stringify(plainText), key, {
    iv: iv,
    mode: CryptoJS.mode.CBC,
  });
  return encrypted;
}

export function decrypted(encrypted) {
  var key = CryptoJS.enc.Utf8.parse("ekatalogapjii_ia");
  var iv = CryptoJS.enc.Utf8.parse("I__20111995__Via");
  var decrypted = CryptoJS.AES.decrypt(encrypted, key, {
    iv: iv,
    mode: CryptoJS.mode.CBC,
  });
  decrypted = decrypted.toString(CryptoJS.enc.Utf8);
  return JSON.parse(decrypted);
}
